/// <amd-module name="Search/Shared/Base/Stores/PreviewOrientationStore" />

import { ObservableValue } from "VSS/Core/Observable";
import { Store } from "VSS/Reflux/Store";
import { IPreviewOrientationChangedPayload } from "Search/Shared/Base/ActionsHub"
import { IVssPageContext } from "VSS/Platform/Context";
import { ISearchLocalSettingsService } from "Search/Shared/Base/LocalSettingsService";

const RightPaneWidth = 0.36;
const MarginAdjustment = 20;

export interface IPreviewOrientationStoreState {
    previewOrientation: string;

    splitterSize: ObservableValue<number>;
}

export class PreviewOrientationStore extends Store {
    protected _state: IPreviewOrientationStoreState;

    constructor(
        changedEvent: string,
        pageContext: IVssPageContext,
        orientationSettingKey: string,
        sizeSettingKey: string,
        defaultOrientation: string) {
        super(changedEvent);

        const settingsService = pageContext.getService<ISearchLocalSettingsService>("ISearchLocalSettingsService");
        const defaultFixedPaneSize = RightPaneWidth * (document.body.clientWidth - MarginAdjustment);
        const splitterSize = settingsService.getValue(sizeSettingKey, defaultFixedPaneSize);

        this._state = {
            previewOrientation: settingsService.getValue(orientationSettingKey, defaultOrientation),
            splitterSize: new ObservableValue<number>(splitterSize)
        };
    }

    public get state(): IPreviewOrientationStoreState {
        return this._state;
    }

    public updatePreviewOrientationMode = (payload: IPreviewOrientationChangedPayload) => {
        this._state.previewOrientation = payload.previewOrientation.key;
        this.emitChanged();
    }
}